var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:({cursor: _vm.adItem.adUrl ? 'pointer' : 'default'}),attrs:{"src":_vm.adItem.imgUrl,"alt":_vm.adItem.name},on:{"click":function($event){return _vm.onAdClick()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b4e2f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/view/index/components/Ad.vue
// module id = null
// module chunks = 